var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9599 22.6013L23.5999 19.9613C23.9554 19.6102 24.4053 19.3698 24.8949 19.2694C25.3844 19.1689 25.8926 19.2128 26.3577 19.3956L29.5752 20.6803C30.0452 20.871 30.4483 21.1967 30.7335 21.6162C31.0188 22.0356 31.1734 22.5302 31.1781 23.0374V28.9303C31.1753 29.2753 31.1028 29.6163 30.9648 29.9325C30.8269 30.2488 30.6263 30.5339 30.3753 30.7707C30.1242 31.0074 29.8278 31.1909 29.504 31.3101C29.1802 31.4293 28.8356 31.4817 28.4909 31.4642C5.94487 30.0617 1.39558 10.9688 0.535227 3.66169C0.495288 3.30286 0.531779 2.93964 0.642298 2.59592C0.752817 2.25221 0.934859 1.93579 1.17645 1.66748C1.41804 1.39917 1.7137 1.18505 2.04398 1.03921C2.37427 0.893375 2.73169 0.819121 3.09273 0.821337H8.78523C9.2932 0.822841 9.78911 0.976281 10.2092 1.26192C10.6292 1.54756 10.9542 1.95234 11.1424 2.42419L12.427 5.64169C12.6159 6.10495 12.6641 6.61359 12.5656 7.10408C12.467 7.59456 12.2262 8.04515 11.8731 8.39955L9.23308 11.0395C9.23308 11.0395 10.7534 21.3285 20.9599 22.6013Z",
    fill: "#C31A7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallI);
export default __webpack_public_path__ + "static/media/callI.44106552b38372ac387fc20993bd66da.svg";
export { ForwardRef as ReactComponent };